// Commonness scores are a 0–1 value but heavily skewed: ~80% of words sit on
// the rank floor (<= 0.05) and only the top ~1% ever pass 0.70, so a raw
// percentage misleads (a "43%" word is already more common than 90% of words).
// Instead we bucket into five friendly tiers keyed to where a word actually
// falls in the frequency pyramid, and never show the number.
export type CommonnessTier = {
   // 0 (rarest) – 4 (most common); drives the meter/chip bar fill.
   level: 0 | 1 | 2 | 3 | 4
   label: 'Obscure' | 'Uncommon' | 'Occasional' | 'Often heard' | 'Very common'
   // One-line piece of learner advice, shown under the usage meter and in the
   // chip tooltip. Phrased as a recommendation, not a restatement of the label.
   description: string
}

export const getCommonnessTier = (commonnessScore: number): CommonnessTier => {
   if (commonnessScore >= 0.7)
      return {
         level: 4,
         label: 'Very common',
         description: 'Learn this early',
      }
   if (commonnessScore >= 0.45)
      return {
         level: 3,
         label: 'Often heard',
         description: 'Worth learning',
      }
   if (commonnessScore >= 0.2)
      return {
         level: 2,
         label: 'Occasional',
         description: 'Not a priority to learn',
      }
   if (commonnessScore >= 0.06)
      return {
         level: 1,
         label: 'Uncommon',
         description: 'Not a priority to learn',
      }
   return {
      level: 0,
      label: 'Obscure',
      description: 'Safe to skip for now',
   }
}
